/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Inheritedqrcodevalidityinminutes5Inputs */

const en__field_inheritedqrcodevalidityinminutes5 = /** @type {(inputs: _Field_Inheritedqrcodevalidityinminutes5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Validity duration of qr code (in minutes) (inherited)`)
};

const de__field_inheritedqrcodevalidityinminutes5 = /** @type {(inputs: _Field_Inheritedqrcodevalidityinminutes5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gültigskeitsdauer QR-Code (in Minuten) (abgeleitet)`)
};

/**
* | output |
* | --- |
* | "Validity duration of qr code (in minutes) (inherited)" |
*
* @param {_Field_Inheritedqrcodevalidityinminutes5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_inheritedqrcodevalidityinminutes5 = /** @type {((inputs?: _Field_Inheritedqrcodevalidityinminutes5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Inheritedqrcodevalidityinminutes5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_inheritedqrcodevalidityinminutes5(inputs)
	return de__field_inheritedqrcodevalidityinminutes5(inputs)
});
export { _field_inheritedqrcodevalidityinminutes5 as "_field_inheritedQrCodeValidityInMinutes" }